export const enum PhoneValidationKind {
    Numeric = 'Numeric',
    CountryFormat = 'CountryFormat',
    VerificationCode = 'VerificationCode',
}

export const enum EmailValidationKind {
    Pattern = 'Pattern',
    VerificationCode = 'VerificationCode',
}
